/**
 * Page Réinitialisation de mot de passe
 * Gère le formulaire de définition du nouveau mot de passe.
 */
document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("reset-password-form");
  const messages = document.getElementById("reset-messages");
  const submitBtn = document.getElementById("reset-submit-btn");

  if (!form) return;

  // =========================================================
  // TOGGLE MOT DE PASSE
  // =========================================================
  document.querySelectorAll(".toggle-password").forEach(function (btn) {
    btn.addEventListener("click", function () {
      const targetId = btn.dataset.target;
      const input = document.getElementById(targetId);
      if (!input) return;
      input.type = input.type === "password" ? "text" : "password";
    });
  });

  // =========================================================
  // SOUMISSION DU FORMULAIRE
  // =========================================================
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    clearMessages();

    const newPassword = form.querySelector('[name="new_password"]').value;
    const confirmPassword = form.querySelector(
      '[name="confirm_password"]',
    ).value;
    const resetKey = form.querySelector('[name="reset_key"]').value;
    const resetLogin = form.querySelector('[name="reset_login"]').value;
    const nonce = form.querySelector('[name="reset_nonce"]').value;

    if (!newPassword || newPassword.length < 8) {
      showMessage(
        "Le mot de passe doit contenir au moins 8 caractères.",
        "error",
      );
      return;
    }

    if (newPassword !== confirmPassword) {
      showMessage("Les mots de passe ne correspondent pas.", "error");
      return;
    }

    const originalText = submitBtn.innerHTML;
    submitBtn.disabled = true;
    submitBtn.innerHTML =
      '<span class="inline-block animate-spin mr-2">↻</span> Enregistrement...';

    const fd = new FormData();
    fd.append("action", "user_reset_password");
    fd.append("nonce", nonce);
    fd.append("reset_key", resetKey);
    fd.append("reset_login", resetLogin);
    fd.append("new_password", newPassword);

    fetch(resetPasswordData.ajaxUrl, { method: "POST", body: fd })
      .then((r) => r.json())
      .then((data) => {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;

        if (data.success) {
          showMessage(
            data.data?.message || "Mot de passe mis à jour !",
            "success",
          );
          form.reset();
          // Redirection vers la page de connexion après 2s
          setTimeout(function () {
            window.location.href = resetPasswordData.loginUrl;
          }, 2000);
        } else {
          showMessage(
            data.data?.message || "Une erreur est survenue.",
            "error",
          );
        }
      })
      .catch(function () {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
        showMessage("Erreur réseau. Veuillez réessayer.", "error");
      });
  });

  // =========================================================
  // UTILITAIRES
  // =========================================================
  function showMessage(msg, type) {
    if (!messages) return;
    const colors = {
      success: "bg-green-100 border-green-400 text-green-700",
      error: "bg-red-100 border-red-400 text-red-700",
    };
    messages.className =
      "mb-6 p-4 border-l-4 " + (colors[type] || colors.error);
    messages.textContent = msg;
    messages.classList.remove("hidden");
  }

  function clearMessages() {
    if (!messages) return;
    messages.classList.add("hidden");
    messages.textContent = "";
  }
});
